// Feld-Validierung ohne alert() (Kehrwoche B, #236 / #31).
//
// Reine Eingabe-Prüfungen („Bitte geben Sie einen Titel ein.") gehören ans Feld,
// nicht in einen Toast — dort gehen sie im Dialog unter. Der Helfer nutzt die
// native Constraint-Validation des Browsers: die Meldung erscheint als Blase
// direkt am Eingabefeld, das Feld bekommt den Fokus, und die Markierung
// verschwindet mit der nächsten Eingabe.
//
// Rückgabe: true, wenn ein Feld gefunden und markiert wurde — sonst false, damit
// der Aufrufer auf einen Toast zurückfallen kann:
//   flagInvalidField(e.currentTarget, '#ticket-title', msg) || pushToast({ type: 'error', message: msg });
export function flagInvalidField(root, selector, message) {
  const scope = root && typeof root.querySelector === 'function' ? root : (typeof document !== 'undefined' ? document : null);
  const el = scope ? scope.querySelector(selector) : null;
  if (!el) return false;
  try {
    if (typeof el.setCustomValidity === 'function') {
      el.setCustomValidity(message || '');
      const clear = () => { try { el.setCustomValidity(''); } catch (_) {} el.removeEventListener('input', clear); };
      el.addEventListener('input', clear);
      if (typeof el.reportValidity === 'function') el.reportValidity();
    }
  } catch (_) {}
  try { el.focus(); } catch (_) {}
  return true;
}
